import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { CalendarEventPage } from '@/features/calendar';

function CalendarEventRoute(): ReactNode {
  const { eventId } = Route.useParams();
  return <CalendarEventPage eventId={eventId} />;
}

export const Route = createFileRoute('/calendar_/events/$eventId')({
  component: CalendarEventRoute,
});
